export interface Notification {
  app_id: string;
  app_notifications: Array<AppNotification>;
}

export interface UserNotificationsRequest {
  notify_new_app?: boolean;
  notify_new_bug?: boolean;
  notify_new_chat_message?: boolean;
  notify_desktop?: boolean;
  notify_unread_activity?: boolean;
}

export interface UserReleasesNotificationsRequest {
  notify_major_releases: boolean;
}

export const enum AppNotificationType {
  NEW_ISSUE = "new_issue",
  NEW_MESSAGE = "new_message",
}

export interface AppNotification {
  issue_id: string;
  is_read: boolean;
  id: string;
  type: AppNotificationType;
  subject_id?: string;
}
